import React, { useContext } from 'react';

import { GlobalContext } from '../../../../../../store';

import Button from '../../../../../../components/Button';
import Modal from '../../../../../../components/Modal';
import { debounce } from '../../../../../../contrib/Utils/debounce';
import {
  useTeeSheetCreatorDispatch,
  useTeeSheetCreatorState
} from '../../Context/TeeSheetCreator.context';
import { useRouteInfoState } from '../../../../../../components/RouteInfo/Context/RouteInfo.context';

export const TeeSheetCreatorModal = () => {
  const {
    actions: {
      adminEventRounds: { swapPlayers, removePlayerFromGroup, clear, autoFill }
    }
  } = useContext(GlobalContext);

  const { clubId, eventId, roundId } = useRouteInfoState();

  const {
    dialogActions,
    dialogOpen,
    dialogText,
    dialogTitle,
    selectedSeat,
    selectedGroup
  } = useTeeSheetCreatorState();

  const {
    actions: { onPlayerAdd },
    dispatch
  } = useTeeSheetCreatorDispatch();

  const onDialogClose = () =>
    dispatch({ type: 'set', value: { attribute: 'dialogOpen', value: false } });

  const onDialogConfirm = async (): Promise<any> => {
    dispatch({ type: 'set', value: { attribute: 'dialogOpen', value: false } });
    const group = selectedGroup;
    const seat = selectedSeat;

    if (dialogActions.toAdd) {
      await onPlayerAdd({ enrollment: dialogActions.toAdd, group, seat }, Number(group));
    } else if (dialogActions.toRemoveId) {
      await removePlayerFromGroup(
        Number(clubId),
        Number(eventId),
        Number(roundId),
        dialogActions.toRemoveId
      );
    } else if (dialogActions.clear) {
      await clear(Number(clubId), Number(eventId), roundId);
    } else if (dialogActions.autoFill) {
      dispatch({ type: 'set', value: { attribute: 'dialogOpen', value: false } });
      await autoFill(Number(clubId), Number(eventId), roundId);
    } else {
      await swapPlayers(
        Number(clubId),
        Number(eventId),
        Number(roundId),
        Number(dialogActions.toSwap1),
        Number(dialogActions.toSwap2)
      );
    }

    dispatch({ type: 'set', value: { attribute: 'dialogOpen', value: false } });
    dispatch({ type: 'set', value: { attribute: 'dialogActions', value: {} } });
    dispatch({ type: 'set', value: { attribute: 'selectedGroup', value: 0 } });

    dispatch({ type: 'set', value: { attribute: 'selectedPlayer', value: 0 } });
    dispatch({ type: 'set', value: { attribute: 'selectedSwap', value: 0 } });
  };

  return (
    <Modal
      id="club15-help-modal"
      open={dialogOpen}
      className="staff-scope"
      title={dialogTitle}
      onClose={onDialogClose}
      actions={[
        <Button
          key="button-cancel"
          onClick={onDialogClose}
          variant="outlined"
          color="primary"
          fullWidth={true}
        >
          CANCEL
        </Button>,
        <Button
          key="button-agree"
          onClick={debounce(onDialogConfirm, 500)}
          variant="contained"
          color="primary"
          fullWidth={true}
        >
          AGREE
        </Button>
      ]}
    >
      <div>{dialogText}</div>
    </Modal>
  );
};
